import { Link } from "react-router-dom";

export const ChannelIndex = () => {
  return (
    <div className="flex justify-center gap-6 mb-12">
    </div>
  );
};